export default "__VITE_ASSET__B7PQxFhr__"